/** The bell and the sidebar draw before this module's chunk loads, so their labels are registered up front (see messages.nav.ts). */
export const notificationsNavEn = {
  "notifications.nav.outbox": "Notification outbox",
  "notifications.nav.templates": "Message templates",
  // Shown by the invitation and statement dialogs too, before this module's screens load.
  "notifications.emailPreview.to": "To",
  "notifications.emailPreview.subject": "Subject",
  "notifications.emailPreview.attachment": "Attachment",
  "notifications.emailPreview.noAddress": "No address",
  "notifications.emailPreview.label": "The email as it will be sent",
  "notifications.bell.label": "Notifications",
} as const;

export const notificationsEn = {
  "notifications.inbox.title": "Notifications",
  "notifications.inbox.subtitle": "What ClubCore told you in this club, newest first.",
  "notifications.inbox.unreadOnly": "Unread only",
  "notifications.inbox.markAll": "Mark all read",
  "notifications.inbox.markRead": "Mark read",
  "notifications.inbox.markReadOf": "Mark “{title}” read",
  "notifications.inbox.open": "Open",
  "notifications.inbox.openOf": "Open “{title}”",
  "notifications.inbox.unread": "Unread",
  "notifications.inbox.settings": "Notification settings",
  "notifications.inbox.marked_one": "{count} notification marked read",
  "notifications.inbox.marked_other": "{count} notifications marked read",
  "notifications.inbox.empty": "Nothing here yet",
  "notifications.inbox.emptyBody": "When something needs you, such as a new member request, it appears here.",
  "notifications.inbox.emptyUnread": "No unread notifications",

  "notifications.settings.title": "Notification settings",
  "notifications.settings.subtitle": "Choose how you hear about each topic. The bell always shows everything.",
  "notifications.settings.topic": "Topic",
  "notifications.settings.urgent": "Sent even in quiet hours",
  "notifications.settings.choice.default": "Club default ({state})",
  "notifications.settings.choice.on": "On",
  "notifications.settings.choice.off": "Off",
  "notifications.settings.state.on": "on",
  "notifications.settings.state.off": "off",
  "notifications.settings.cell": "{topic}: {channel}",
  "notifications.settings.quiet": "Quiet hours",
  "notifications.settings.quietHint": "Texts and app alerts wait until quiet hours end. Email and the bell are not held.",
  "notifications.settings.quiet.club": "Follow the club ({start} to {end})",
  "notifications.settings.quiet.clubNone": "Follow the club (none set)",
  "notifications.settings.quiet.own": "My own hours",
  "notifications.settings.quiet.off": "No quiet hours",
  "notifications.settings.quietMode": "Quiet hours",
  "notifications.settings.quietStart": "From",
  "notifications.settings.quietEnd": "Until",
  "notifications.settings.language": "Language of notifications",
  "notifications.settings.language.club": "The club's language",
  "notifications.settings.language.en": "English",
  "notifications.settings.language.es": "Spanish",
  "notifications.settings.timezone": "Time zone",
  "notifications.settings.timezoneHint": "Leave empty to use the club's ({zone}).",
  "notifications.settings.save": "Save",
  "notifications.settings.saved": "Notification settings saved",
  "notifications.settings.nothingToChoose": "No staff topics are sent by email or text yet.",

  "notifications.channel.email": "Email",
  "notifications.channel.text": "Text",
  "notifications.channel.push": "App",
  "notifications.channel.voice": "Voice",
  "notifications.channel.in_app": "Bell or inbox",

  "notifications.topic.tee_time_confirmation": "Tee time confirmation",
  "notifications.topic.tee_time_reminder": "Tee time reminder",
  "notifications.topic.statement_ready": "Statement ready",
  "notifications.topic.bill_due": "Bill due",
  "notifications.topic.guest_arrival_staff": "Guest arrivals",
  "notifications.topic.weather_closure": "Weather and course closure",
  "notifications.topic.service_request_update": "Replies to member requests",
  "notifications.topic.lodging_request_update": "Stay request answers",
  "notifications.topic.member_request_staff": "New member requests",
  "notifications.topic.tee_time_cancelled": "Tee time cancelled",
  "notifications.topic.event_signup_update": "Event sign-up updates",
  "notifications.topic.dining_reservation_update": "Dining reservation answers",
  "notifications.topic.dining_reservation_staff": "Dining requests",

  "notifications.unavailable.email_configured": "Email sending is not activated yet",
  "notifications.unavailable.email_off": "The club does not send email",
  "notifications.unavailable.email_incomplete": "The club's email settings are incomplete",
  "notifications.unavailable.email_insecure": "The club's email settings are not secure",
  "notifications.unavailable.sms_not_available": "Texting is not available yet",
  "notifications.unavailable.not_configured": "The phone system is not set up for texts",
  "notifications.unavailable.no_sms_number": "The club has no texting number",
  "notifications.unavailable.push_not_set_up": "The app is not available yet",
  "notifications.unavailable.other": "Not available yet",

  "notifications.outbox.title": "Notification outbox",
  "notifications.outbox.subtitle": "Emails and texts leaving the club, and why any are waiting. What a message says is not shown here.",
  "notifications.outbox.held_one": "{count} email is held because email sending is not activated. It goes out when email is activated in Club settings > Communications, if it is still recent enough.",
  "notifications.outbox.held_other": "{count} emails are held because email sending is not activated. They go out when email is activated in Club settings > Communications, if they are still recent enough.",
  "notifications.outbox.status": "Status",
  "notifications.outbox.allStatuses": "All statuses",
  "notifications.outbox.channel": "Channel",
  "notifications.outbox.allChannels": "Email and text",
  "notifications.outbox.col.created": "Created",
  "notifications.outbox.col.topic": "Topic",
  "notifications.outbox.col.recipient": "To",
  "notifications.outbox.col.channel": "Channel",
  "notifications.outbox.col.status": "Status",
  "notifications.outbox.col.attempts": "Tries",
  "notifications.outbox.col.actions": "Actions",
  "notifications.outbox.nextTry": "Next: {time}",
  "notifications.outbox.retry": "Retry",
  "notifications.outbox.retryOf": "Retry the message to {name}",
  "notifications.outbox.cancel": "Cancel",
  "notifications.outbox.cancelOf": "Cancel the message to {name}",
  "notifications.outbox.retried": "The message is queued again",
  "notifications.outbox.cancelled": "The message was cancelled",
  "notifications.outbox.empty": "Nothing has been sent yet",
  "notifications.outbox.emptyFiltered": "No messages match these filters",
  "notifications.outbox.someone": "Someone",

  "notifications.status.pending": "Waiting to send",
  "notifications.status.scheduled": "Scheduled",
  "notifications.status.held": "Held",
  "notifications.status.sending": "Sending",
  "notifications.status.sent": "Sent",
  "notifications.status.delivered": "Delivered",
  "notifications.status.failed": "Failed",
  "notifications.status.suppressed": "Blocked",
  "notifications.status.skipped": "Skipped",
  "notifications.status.expired": "Expired",
  "notifications.status.cancelled": "Cancelled",

  "notifications.reason.email_configured": "email not activated",
  "notifications.reason.email_off": "email off",
  "notifications.reason.email_incomplete": "email settings incomplete",
  "notifications.reason.sms_not_available": "texting not available yet",
  "notifications.reason.no_sms_number": "no texting number",
  "notifications.reason.not_configured": "phone system not set up",
  "notifications.reason.quiet_hours": "quiet hours",
  "notifications.reason.rate_limited": "hourly limit reached",
  "notifications.reason.retrying": "will try again",
  "notifications.reason.no_address": "no address on file",
  "notifications.reason.bounce": "address refused before",
  "notifications.reason.opted_out": "replied STOP",
  "notifications.reason.recipient_refused": "the mail server refused the address",
  "notifications.reason.gave_up": "gave up after 6 tries",
  "notifications.reason.outcome_unknown": "not known whether it was sent",
  "notifications.topic.phone_message_staff": "New phone messages (to staff)",
  "notifications.topic.account_invite": "Member invitation",
  "notifications.topic.account_magic_link": "Sign-in link",
  "notifications.topic.account_password_reset": "Password reset",
  "notifications.topic.account_pin_reset": "PIN reset",
  "notifications.topic.account_step_up": "Confirm it is you",
  "notifications.topic.statement_email": "Statement email",

  "notifications.templates.title": "Message templates",
  "notifications.templates.subtitle": "Read and change the wording of everything ClubCore sends for this club, in English and Spanish. Messages already waiting keep the wording they were made with.",
  "notifications.templates.group": "Messages",
  "notifications.templates.group.all": "All messages",
  "notifications.templates.group.notification": "Notifications",
  "notifications.templates.group.account": "Member account emails",
  "notifications.templates.group.statement": "Statement email",
  "notifications.templates.language": "Language",
  "notifications.templates.language.en": "English",
  "notifications.templates.language.es": "Spanish",
  "notifications.templates.table": "Message templates",
  "notifications.templates.col.message": "Message",
  "notifications.templates.col.channel": "Sent by",
  "notifications.templates.col.subject": "Subject or title",
  "notifications.templates.col.wording": "Wording",
  "notifications.templates.col.action": "Change",
  "notifications.templates.builtin": "Built-in",
  "notifications.templates.custom": "This club's",
  "notifications.templates.edit": "Edit",
  "notifications.templates.editOf": "Edit {message} ({channel})",
  "notifications.templates.editTitle": "{message}: {channel}, {language}",
  "notifications.templates.editBody": "Type the wording, and put a variable where ClubCore fills in a value for each person.",
  "notifications.templates.subject": "Subject",
  "notifications.templates.titleField": "Title",
  "notifications.templates.body": "Message",
  "notifications.templates.variables": "Variables",
  "notifications.templates.variablesHint": "Choose one to put it where the cursor is.",
  "notifications.templates.insert": "Insert {name}",
  "notifications.templates.required": "Keep {names}: the message does not work without it.",
  "notifications.templates.preview": "Preview with sample values",
  "notifications.templates.previewing": "Updating the preview…",
  "notifications.templates.problems": "Fix these before saving",
  "notifications.templates.save": "Save wording",
  "notifications.templates.saved": "Wording saved",
  "notifications.templates.reset": "Go back to the built-in wording",
  "notifications.templates.resetDone": "Built-in wording restored",
  "notifications.templates.empty": "No messages match",

} as const;

export type NotificationsMessages = typeof notificationsEn & typeof notificationsNavEn;
